var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdhibitionList',{attrs:{"enterpriseData":_vm.enterpriseData}})
}
var staticRenderFns = []

export { render, staticRenderFns }